import { SxProps } from '@hermes/web-components'

export enum PAGE_VARIANTS {
  CONNECT = 'connect',
  OTHER = 'other',
  HCA = 'hca',
  WPA = 'wpa'
}

export enum PROVIDERS_VARIANTS {
  HCA = 'hca',
  WPA = 'wpa'
}

export type ToBooleanFields<T> = {
  [K in keyof T]?: boolean | string
}

export interface ProfileProps {
  id: number
  fullName: Record<string, string>
  slug: string
  plan: string
  networkOnly: boolean
  status: string
  relationships: { sourceName: Record<string, string>; targetName: Record<string, string> }[]
  tenants: string[]
}

export interface ClaimYourProfileProps {
  profile: ProfileProps
  lang: string
  slug: string
  connectVariant?: boolean
  variant?: PAGE_VARIANTS
}

export interface FormFieldStateProps {
  [key: string]: string
}

export type VariantSxReturnProps = Partial<Record<PAGE_VARIANTS, SxProps>>
